"use client";

import { motion } from "framer-motion";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Image from "@/app/_components/Image";

// eslint-disable-next-line import/order
import { tournaments } from "./tournaments.data";

import "swiper/css";
import "swiper/css/pagination";

import styles from "./TournamentSection.module.scss";

export default function TournamentSection() {
  return (
    <section className={styles.section}>
      <motion.div
        className={styles.innerCard}
        initial={{
          opacity: 0,
          y: 80,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        viewport={{
          once: true,
          amount: 0.2,
        }}
        transition={{
          duration: 1,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        <motion.div
          className={styles.heading}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.18,
              },
            },
          }}
        >
          <motion.h2
            variants={{
              hidden: {
                opacity: 0,
                y: 30,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{
              duration: 0.8,
            }}
          >
            Together, Toward Inspiration
          </motion.h2>

          <motion.p
            variants={{
              hidden: {
                opacity: 0,
                y: 30,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{
              duration: 0.8,
            }}
          >
            Beyond individual tournaments, Kia has partnered with numerous
            international football competitions organized by FIFA. The FIFA
            World Cup 2026™ marks another meaningful milestone in this
            journey, continuing a long-standing partnership built on shared
            values.
          </motion.p>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0,
            y: 40,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 1,
            delay: 0.3,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
         <Swiper
            modules={[Navigation, Pagination]}
            centeredSlides={true}
            loop={true}
            slidesPerView={5}
            slidesPerGroup={1}
            speed={600}
            spaceBetween={0}
            navigation={true}
            pagination={{
              clickable: true,
            }}
            className={styles.slider}
            breakpoints={{
              0: {
                slidesPerView: 1.4,
              },
              768: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 5,
              },
            }}
          >
            {tournaments.map((item) => (
              <SwiperSlide
                key={item.id}
                className={styles.slide}
              >
                <div className={styles.imageWrap}>
                  <Image
                    src={item.inactive}
                    alt={item.title}
                    title={item.title}
                    fill
                    className={styles.inactiveImage}
                    sizes="(max-width: 768px) 70vw, (max-width: 1200px) 33vw, 20vw"
                    quality={70}
                    loading="lazy"
                  />

                  <Image
                    src={item.active}
                    alt={item.title}
                    title={item.title}
                    fill
                    className={styles.activeImage}
                    sizes="(max-width: 768px) 70vw, (max-width: 1200px) 33vw, 20vw"
                    quality={70}
                    loading="lazy"
                  />
                </div>

                <p className={styles.slideText}>{item.title}</p>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </motion.div>
    </section>
  );
}